import { FlagsComponentRouter } from 'flags'

import OffComponent from './flag.off/component'
import OnComponent from './flag.on/component'

const FlagToggler = FlagsComponentRouter({
  flagSubscriptions: ['feature_LEARN-27700_core-lesson-completion-updates'],
  OnComponent,
  OffComponent,
})

export default FlagToggler
